import { IQuiz } from '../IQuiz'

export const dipPatterns1: IQuiz = {
  name: 'dip-patterns-1',
  question: 'В чём польза инъекции зависимостей?',
  variants: [
    {
      text: 'Прячет зависимости от прямого объявления, что делает код чище',
      description:
        'При инъекции зависимостей код может стать многословнее, но взамен мы получаем больший контроль и упрощённое тестирование'
    },
    {
      text: 'Делает тестирование с фейковыми объектами проще'
    },
    {
      text: 'Позволяет отвязать модули от конкретных классов, заменяя их на абстракцию'
    }
  ],
  meta: {
    correctAnswers: [1, 2]
  }
}
